import React from 'react'
import './Testimonials.css';
import avatar1 from '../../assets/zeeshan-mukhtar.jpg';
import avatar2 from '../../assets/Ali-Qureshi.jpeg';
import owais from '../../assets/newTestimonial3.jpg';
import noman from '../../assets/newTestimonial2.jpg';
import arham from '../../assets/newTestimonial1.jpg';
import shahzaib from '../../assets/newTestimonial4.jpg';
import azhar from '../../assets/newTestimonial5.jpg';
import abdulMoiz from '../../assets/newTestimonial6.png';

import { Pagination, Autoplay } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const data = [
  {
    avatar: owais,
    name: 'Owais Shaikh',
    review: "Working with Maaz has been a genuinely rewarding experience. His technical abilities are top-notch. He picks up new technologies quickly, writes clean and thoughtful work, and always brings a solutions-oriented mindset to the table. Beyond the skills themselves, he's the kind of colleague who raises the bar for everyone around him. I'd recommend Maaz without hesitation to anyone looking for a technically strong and dependable professional."
  },
  {
    avatar: noman,
    name: 'Muhammad Noman',
    review: "Syed Maaz Saeed owns powerful expertise across multiple domains, especially in agentic workflows using n8n as well as CI/CD pipelines. He knows very well how to make a web app scalable, and personally I am a fan of his debugging skills. He uses a well-structured approach to find the actual error in large applications very efficiently and in less time. No sugarcoating, no biased review, just a personal opinion from my side."
  },
  {
    avatar: arham,
    name: 'Arham Khan',
    review: "I've worked with Maaz on several projects, and what always stands out isn't just his technical skill, but his reliability. He has this rare ability to jump into a messy n8n workflow, find the one tracking issue that's breaking everything, and fix it without making a fuss. He's incredibly dedicated to the project goals and never misses a beat. If you need someone who actually listens and delivers exactly what's needed, Maaz is your guy."
  },
  {
    avatar: shahzaib,
    name: 'Shahzaib Shah',
    review: "I've worked with a lot of developers. Most of them need detailed briefs, clear specs, and constant back-and-forth before anything moves. Maaz is different.\n\nI'm a marketer with minimal technical background. I explain things in plain English, sometimes messily, and Maaz just gets it. Not just the surface request, but the actual problem underneath it. He takes that and builds something that works, usually going well beyond what I asked for.\n\nWhat stands out most is that he doesn't just deliver. He figures out what needs to be done and does it, even when the problem is complex and the brief is vague. I've seen him turn ambiguous ideas into clean, working automation workflows without ever making me feel like I was asking for too much.\n\nHe's the kind of person you want on a project when things actually need to get done, not just discussed. Reliable, sharp, and genuinely invested in the outcome. If you're looking for an AI automation engineer who delivers, Maaz is someone I'd recommend without hesitation."
  },
  {
    avatar: azhar,
    name: 'Azhar Mehdi',
    review: "I had the pleasure of studying alongside Maaz, and what sets him apart is his rare ability to not just write code but engineer solutions. Whether it is building scalable full-stack applications or designing intelligent automation workflows, he approaches every challenge with a gold medalist's mindset and delivers results that genuinely move the needle.\n\nIf you are looking for someone who can bring your SaaS idea to life or automate complex business processes with AI, Maaz is exactly who you want on your team."
  },
  {
    avatar: abdulMoiz,
    name: 'Abdul Moiz Siddiqui',
    review: "I work directly with Maaz at Remap.ai and can say without hesitation, he is one of the most reliable people on our team.\n\nMaaz operates at the intersection of full-stack development and AI automation, which is a rare combination. He has built and shipped production web applications, integrated AI-powered chatbots using RAG and vector databases, and owns end-to-end n8n workflow automation for multiple live client campaigns. He handles everything from LLM prompt engineering and OpenAI API optimization to NocoDB integrations, email deliverability, and agentic AI pipelines using tools like OpenClaw.\n\nWhat actually sets him apart is that he does not just build things, he keeps them running. When a campaign breaks mid-execution or an API throws a quota error, Maaz diagnoses and fixes it fast. He has also done meaningful R&D work independently, including implementing a Qdrant hybrid search RAG pipeline and building Claude Code-based agents during an internal hackathon.\n\nIf you are looking for someone strong in AI automation, agentic workflows, LLMOps, n8n, RAG, full-stack development, and real-world AI deployment, Maaz is genuinely that person. He is still with us at Remap.ai and growing fast."
  },
  {
    avatar: avatar1,
    name: 'Zeeshan Mukhtar',
    review: 'I highly recommend Maaz. As his React and JavaScript instructor at CodeLab, he grasped concepts quickly, solved problems creatively, and collaborated well. A talented developer to watch! He is a talented developer with a bright future.'
  },
  {
    avatar: avatar2,
    name: 'Ali Qureshi',
    review: 'Syed Maaz Saeed is a highly skilled Front-End Developer and React-Redux Developer. His proficiency with MERN stack services, frontend programming, React, and Redux has been invaluable to the success of our projects. His dedication to high-quality solutions has been outstanding.'
  }
]
const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>Professional Endorsements</h5>
      <h2>What Peers Are Saying</h2>

      <Swiper className="container testimonials__container"

        // install Swiper modules
        modules={[Pagination, Autoplay]}
        spaceBetween={40}
        slidesPerView={1}
        // navigation
        autoplay={{ delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true }}

        pagination={{ clickable: true }}
      >

        {
          data.map(({ avatar, name, review }, index) => {

            return (
              <SwiperSlide key={index} className="testimonial">
                <div className="client__avatar">
                  <img src={avatar} alt={`Avatar of ${name}`} loading="lazy" decoding="async" />
                </div>
                <h5 className='client__name'>
                  {name}
                </h5>
                <small className={`client__review ${review.includes('\n') ? 'client__review--long' : ''}`}>
                  {review}
                </small>
              </SwiperSlide>
            )
          })
        }

      </Swiper>


    </section>
  )
}

export default Testimonials
